import { internalComponentDefinition } from '../../../helpers/component.js';
import { mergeConfiguration } from '../../../helpers/factory.js';
import PortfolioEvaluationChart from '../PortfolioEvaluationChart.vue.js';

const DEFAULT_COMPONENT_NAME = "fds-portfolio-evaluation-chart";
const defaultPortfolioEvaluationChartHighChartOptions = {
  time: {
    useUTC: false
  },
  chart: {
    styledMode: true,
    spacing: [0, 0, 0, 0]
  },
  title: {
    text: ""
  },
  credits: { enabled: false },
  legend: { enabled: false },
  xAxis: {
    type: "datetime",
    ordinal: true,
    tickPixelInterval: 115,
    minorTickInterval: "",
    crosshair: {
      snap: false
    },
    tickLength: 6,
    tickAmount: 5,
    dateTimeLabelFormats: {
      day: "%e. %b",
      week: "%e. %b '%y",
      month: "%e. %b '%y",
      year: "%Y"
    }
  },
  yAxis: {
    tickLength: 6,
    tickAmount: 5,
    opposite: false,
    crosshair: {
      snap: false
    },
    title: {
      text: ""
    },
    showLastLabel: false,
    showFirstLabel: true
  },
  plotOptions: {
    series: {
      lineWidth: 2,
      crisp: false,
      states: {
        hover: {
          lineWidth: 2
        }
      },
      marker: {
        enabled: false
      }
    },
    line: {
      marker: {
        states: {
          hover: {
            enabled: true
          },
          select: {
            enabled: false
          }
        }
      }
    },
    area: {
      marker: {
        enabled: false,
        states: {
          hover: {
            enabled: true
          },
          select: {
            enabled: false
          }
        }
      },
      states: {
        hover: {
          lineWidth: 1
        }
      },
      threshold: null
    }
  },
  series: [
    {
      type: "line",
      id: "prices",
      name: "",
      data: [],
      turboThreshold: 2e3,
      yAxis: 0
    },
    {
      type: "line",
      id: "prices",
      name: "",
      data: [],
      turboThreshold: 2e3,
      yAxis: 0
    },
    {
      type: "line",
      id: "prices",
      name: "",
      data: [],
      turboThreshold: 2e3,
      yAxis: 0
    }
  ]
};
const defaultPortfolioEvaluationChartHighChartOptionsHelper = (params) => {
  const { range } = params;
  const { dateFormat, numberFormat, translate } = params.localizationSupport;
  const options = {
    ...defaultPortfolioEvaluationChartHighChartOptions,
    xAxis: {
      ...defaultPortfolioEvaluationChartHighChartOptions.xAxis,
      minTickInterval: 0,
      labels: {
        formatter() {
          return dateFormat(new Date(this.value), { format: "dayAndMonth" });
        }
      },
      accessibility: {
        rangeDescription: translate("portfolioEvaluationChart.rangeDescription", { start: dateFormat(range.start), end: dateFormat(range.end) })
      }
    },
    tooltip: {
      formatter() {
        const date = this.x !== void 0 ? new Date(this.x) : this.x;
        return `${dateFormat(date, { format: "onlyDate" })}<br/><b>${numberFormat(this.y)}</b>`;
      }
    }
  };
  return options;
};
const defaultPortfolioEvaluationChartConfiguration = {
  options: {
    componentName: DEFAULT_COMPONENT_NAME,
    highChartOptions: defaultPortfolioEvaluationChartHighChartOptionsHelper
  }
};
const portfolioEvaluationChartFactory = (configuration) => {
  var _a, _b, _c, _d;
  const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultPortfolioEvaluationChartConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
  const mergedConfiguration = mergeConfiguration(configuration, defaultPortfolioEvaluationChartConfiguration);
  return internalComponentDefinition(componentName, mergedConfiguration, PortfolioEvaluationChart);
};
const portfolioEvaluationChartPlugin = {
  install(Vue, configuration = defaultPortfolioEvaluationChartConfiguration) {
    var _a, _b, _c, _d;
    const componentName = (_d = (_c = (_a = configuration.options) == null ? void 0 : _a.componentName) != null ? _c : (_b = defaultPortfolioEvaluationChartConfiguration.options) == null ? void 0 : _b.componentName) != null ? _d : DEFAULT_COMPONENT_NAME;
    Vue.component(componentName, portfolioEvaluationChartFactory(configuration));
  }
};

export { defaultPortfolioEvaluationChartConfiguration, defaultPortfolioEvaluationChartHighChartOptions, defaultPortfolioEvaluationChartHighChartOptionsHelper, portfolioEvaluationChartFactory, portfolioEvaluationChartPlugin };
